<template>
  <v-app id="app">  
    <!--  header-section start  -->
    <AppBar/>
    <!-- Contenido de cada vista se visualiza en esta seccion  -->
    <v-main>
      <router-view :key="$route.fullPath" />
    </v-main>
    <!-- footer -->
    <v-footer class="app-footer" dark padless>
      <div class="footer-top-accent"></div>
      <v-container class="footer-container py-10 px-4">
        <v-row justify="space-between" align="start">
          <!-- Columna 1: Marca y slogan -->
          <v-col cols="12" md="4" sm="12" :class="$vuetify.breakpoint.xs ? 'text-center mb-6' : 'mb-4'">
            <div class="footer-brand" :class="$vuetify.breakpoint.xs ? 'd-flex flex-column align-center' : ''">
              <div class="footer-logo-wrapper mb-3">
                <img
                  src="/assets/images/logo_red.webp"
                  alt="RADA Rent a Car"
                  class="footer-logo"
                  @click="redirectListItem('/')"
                />
              </div>
              <p class="footer-slogan">
                La flota más amplia y moderna del Norte Argentino
              </p>
            </div>
          </v-col>

          <!-- Columna 2: Contacto -->
          <v-col cols="12" md="5" sm="7" :class="$vuetify.breakpoint.xs ? 'text-center mb-6' : 'mb-4'">
            <div class="footer-section-title-wrap">
              <h4 class="footer-heading">Contacto</h4>
              <div class="footer-heading-line" :class="$vuetify.breakpoint.xs ? 'mx-auto' : ''"></div>
            </div>
            <div class="footer-contact-list mt-3">
              <div
                v-for="(contanct, index) in contactos"
                :key="index"
                class="footer-contact-item mb-3"
                :class="$vuetify.breakpoint.xs ? 'justify-center' : ''"
              >
                <div class="contact-icon-box mr-3">
                  <v-icon small color="#e53935">{{ contanct.icon }}</v-icon>
                </div>
                <a
                  v-if="isContactLink(contanct)"
                  :href="getContactHref(contanct)"
                  :target="getContactTarget(contanct)"
                  rel="noopener noreferrer"
                  class="contact-link"
                >
                  {{ contanct.valor }}
                </a>
                <span v-else class="contact-val">
                  {{ contanct.valor }}
                </span>
              </div>
            </div>
          </v-col>

          <!-- Columna 3: Redes -->
          <v-col cols="12" md="3" sm="5" :class="$vuetify.breakpoint.xs ? 'text-center' : ''">
            <div class="footer-section-title-wrap">
              <h4 class="footer-heading">¡Síguenos!</h4>
              <div class="footer-heading-line" :class="$vuetify.breakpoint.xs ? 'mx-auto' : ''"></div>
            </div>
            <p class="footer-social-desc mt-3">
              Conectate en nuestras redes oficiales
            </p>
            <div class="footer-social-list mt-2" :class="$vuetify.breakpoint.xs ? 'justify-center' : ''">
              <a
                v-for="(red, index) in redes"
                :key="index"
                :href="red.redirect"
                target="_blank"
                rel="noopener noreferrer"
                class="footer-social-icon-btn mx-1"
                :title="red.icon"
              >
                <v-icon size="20px" color="white">{{ red.icon }}</v-icon>
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- Barra de derechos -->
      <div class="footer-bottom-bar w-100 py-4">
        <v-container class="py-0">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-center">
              <span class="footer-copyright-text">
                RADA S.R.L © {{ new Date().getFullYear() }} | Todos los derechos reservados
              </span>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-footer>
    <!-- footer-section end -->
    <!-- Modal Select Idioma -->
    <!-- <v-row justify="center">
      <v-dialog v-model="dialogLenguage" max-width="200px" scrollable>
        <v-card>
          <v-toolbar color="red darken-1" height="50%" flat dark>
            <v-toolbar-title>
              <v-icon>mdi-translate</v-icon> {{ $t('idiomas') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-chip-group v-for="entry in languages" :key="entry.title" style="margin-top:5px" column>
              <v-chip class="ma-2" pill @click="changeLocale(entry)">
                <v-avatar>
                  <flag :iso="entry.flag" v-bind:squared=false />
                </v-avatar>
                <span class="mx-2">
                  {{ entry.title }}
                </span>
              </v-chip>
            </v-chip-group>
          </v-card-text>        
        </v-card>
      </v-dialog>
    </v-row> -->
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex"
import { storage, database } from "@/firebase"
import { VueTypedJs } from 'vue-typed-js'
import i18n from '@/plugins/i18n'
import AppBar from "./components/AppBar.vue"

export default {
  name: 'app',
  components: {
    VueTypedJs,
    AppBar
  },
  data: () => ({
    languages: [
      { flag: 'us', language: 'en', title: 'English' },
      { flag: 'es', language: 'es', title: 'Español' },
    ],
    drawer: false,
    group: null,
    dialogLenguage: false,
    idioma: 'Idioma',
    user_locale: '',
    checkMobileDevice: false,
    band: false,
    urlImgBanner: null,
    isActive: true,
    isShow: false,
    arrayAutos: [],
    menu: [
      { title: 'Alquilar', icon: 'mdi-car-side', redirect: '/reserva' },
      { title: 'Flota', icon: 'mdi-forum', redirect: '/flota' },
      { title: 'Beneficios', icon: 'mdi-gift', redirect: '/beneficios' },
      { title: 'Contacto', icon: 'mdi-phone', redirect: '/contacto' },
      { title: 'Idioma', icon: 'mdi-forum' },
    ],

  }),
  async created() {
    this.getImagenes()
    this.getLocale()
    this.mobilecheck()
    if (this.contactos.length === 0) {
      this.getContacto()
    }
    if (this.redes.length === 0) {
      this.getRedes()
    }
  },
  computed:{
    ...mapState(['contactos','redes'])
  },
  methods: {
    ...mapActions(['getContacto','getRedes']),
    changeLocale(locale_select) {
      //cambia el idioma de la pagina
      localStorage.idioma = {...locale_select}
      i18n.locale = locale_select.language
      this.idioma = locale_select.title
    },
    getLocale() {
      //obtiene el idioma del navegador
      this.user_locale = window.navigator.language.substring(-6, 2)
    },
    mobilecheck() {
      //obtiene el tipo de dispositivo 
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      this.checkMobileDevice = check
    },
    async getImagenes() {
      try {
        const refImagen = storage.ref().child('/imagenes/banners/banner_header.jpg')
        this.urlImgBanner = await refImagen.getDownloadURL()
      } catch (error) {
        console.log(error)
      }
    },
    openModalLenguage() {
      this.drawer = false
      this.isShow = true
      this.dialogLenguage = true
    },
    getData() {
      let data = []
      let autos = database.ref("autos")
      autos.once("value")
        .then(function(snapshot) {
          snapshot.forEach(doc => {
            data.push({ 
              id : doc.val().id,
              name : doc.val().name,
              public_image_link : doc.val().public_image_link,
              short_description_for_website : doc.val().short_description_for_website,
              order : doc.val().order,
              brand : doc.val().brand,
              activeRates : doc.val().activeRates,
            })                                                  
          })
        })
      this.arrayAutos = data
      this.arrayAutos = data
    },
    redirectListItem(path) {
      //Redirect pages
      if (this.$route.path != path) this.$router.push(path)
    },
    isContactLink(contact) {
      if (!contact || !contact.valor) return false
      const val = contact.valor.toLowerCase()
      const icon = (contact.icon || '').toLowerCase()
      return val.includes('@') || icon.includes('phone') || icon.includes('whatsapp') || val.startsWith('+') || icon.includes('map') || icon.includes('marker')
    },
    getContactHref(contact) {
      if (!contact || !contact.valor) return '#'
      const val = contact.valor.trim()
      const icon = (contact.icon || '').toLowerCase()
      if (val.includes('@') || icon.includes('email') || icon.includes('mail')) {
        return `mailto:${val}`
      }
      if (icon.includes('phone') || icon.includes('whatsapp') || val.startsWith('+') || /^[0-9+ \-]+$/.test(val)) {
        const clean = val.replace(/[^0-9+]/g, '')
        return `tel:${clean}`
      }
      if (icon.includes('map') || icon.includes('marker') || icon.includes('location')) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(val)}`
      }
      return '#'
    },
    getContactTarget(contact) {
      const icon = (contact.icon || '').toLowerCase()
      if (icon.includes('map') || icon.includes('marker') || icon.includes('location')) {
        return '_blank'
      }
      return '_self'
    }
  },
  watch:{
    user_locale: function() {
      let lang = this.languages.filter( lang => lang.language == this.user_locale)
      this.changeLocale(lang[0])
    }, 
    dialog: function() {
      if (!this.dialog) {
        this.band = true
      }
    },
    dialogLenguage: function() {
      if (!this.dialogLenguage) {
        this.isShow = false
      }
    }
  }
}
</script>

<style>
/* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@700;800&display=swap'); */

/* .header-button{
  font-family: 'Inter', sans-serif !important;
  color: #ffffff ;
  font-size: 20px;
} */

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(.17, .67, .83, .67);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(800px);
  opacity: 0;
}

.button_lang {
  padding: 15px;
  font-size: 12px;
  margin: 10px;
  background: aliceblue;
}
</style>

<style scoped>
  .custom-divider {
    background-color: white;
    height: 20px;
    width: 2px;
    margin: 0 0px;
  }
  .custom-title {
    text-transform: none;
  }

  .app-footer {
    background: linear-gradient(180deg, #181c24 0%, #0f1217 100%) !important;
    color: #e2e8f0 !important;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
  }

  .footer-top-accent {
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #e53935 0%, #b71c1c 50%, #e53935 100%);
  }

  .footer-container {
    max-width: 1140px;
  }

  .footer-logo {
    height: 62px;
    width: auto;
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.25s ease;
  }

  .footer-logo:hover {
    transform: scale(1.05);
  }

  .footer-slogan {
    color: #94a3b8;
    font-size: 14px;
    line-height: 1.6;
    max-width: 300px;
    margin-bottom: 0;
  }

  .footer-heading {
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 6px;
  }

  .footer-heading-line {
    width: 32px;
    height: 2px;
    background-color: #e53935;
    border-radius: 2px;
  }

  .footer-contact-list {
    display: flex;
    flex-direction: column;
  }

  .footer-contact-item {
    display: flex;
    align-items: center;
    transition: transform 0.2s ease;
  }

  .footer-contact-item:hover {
    transform: translateX(4px);
  }

  .contact-icon-box {
    width: 34px;
    height: 34px;
    min-width: 34px;
    border-radius: 8px;
    background: rgba(229, 57, 53, 0.12);
    border: 1px solid rgba(229, 57, 53, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .contact-link,
  .contact-val {
    font-size: 14px;
    color: #cbd5e1 !important;
    text-decoration: none;
    transition: color 0.2s ease;
    word-break: break-word;
  }

  .contact-link:hover {
    color: #ffffff !important;
    text-decoration: underline;
  }

  .footer-social-desc {
    color: #94a3b8;
    font-size: 14px;
    margin-bottom: 8px;
  }

  .footer-social-list {
    display: flex;
    align-items: center;
  }

  .footer-social-icon-btn {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.14);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: all 0.25s ease;
  }

  .footer-social-icon-btn:hover {
    background: #e53935;
    border-color: #e53935;
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(229, 57, 53, 0.45);
  }

  .footer-bottom-bar {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background-color: rgba(0, 0, 0, 0.3);
  }

  .footer-copyright-text {
    font-size: 13px;
    color: #94a3b8;
    letter-spacing: 0.3px;
  }
</style>